angular.module("digitalLeasing.module").component("bankResolutionNpl", {
    templateUrl: "ng/components/digitalLeasing/resolutionNuovoPrestoLeasing/bankResolution/bankResolutionNpl.view.html",
    bindings: {
      model: "=",
      domande: "=",
      price: "<",
      priceGuarantee: "<",
      product: "<",
      toggleDatePicker: "<",
      customer: "<",
      date: "=",
      grantedResolution: "=", 
      check: "&",
      leasingData:'<',
      financialVendor:'<'
    },
    controllerAs: "bankResolutionNplCtrl",
    controller: function bankResolutionNpl(
      $financialApiService,
      $typeDomainService,
      $scope,
      $timeout,
      $modalService
    ) {
      var self = this;
  
      self.questions = [{}]

      self.$onInit = function () {
        self.restIsPending = true;
        self.noteConfirmed = false;
        console.log("model", self.model);
        if (self.grantedResolution === undefined) {
          self.grantedResolution = true
        }
        getAllAbi();
        callRestPerGaranzie();    
      };


      self.handleChange = function(property, value) {
        switch(property) {
          case "date":
            self.date = value;
            break;
          case "grantedResolution":
            self.grantedResolution = value;
            break;
          case "numberOfGuarrantee":
          self.model.nGaranzia= value;
          break;
        }
        self.validate();
      }

      self.validate = function () {
        if(!self.showNote){
          var test= (self.grantedResolution || !self.grantedResolution || self.grantedResolution != null) && 
          $scope.bankResolutionNpl && $scope.bankResolutionNpl.$valid
        } else {
          var test= (self.grantedResolution || !self.grantedResolution || self.grantedResolution != null) && 
          $scope.bankResolutionNpl && $scope.bankResolutionNpl.$valid && self.noteConfirmed
        }
        if(test) {
          self.check({
            validation: true,
            mode: "R"
          });
        } else {
          self.check({
            validation: false,
            mode: "R"
          });
        }
      }

      var callRestPerGaranzie = function(){
        $financialApiService.percentualeGarBanca(self.leasingData.contratto.numero, self.leasingData.contratto.modulo)
        .then(function(response){
          self.restIsPending = false;
          if(response.success){
            self.model.percentualeGaranziaBanca =response.percentualeCopertura;
            self.model.importoDeliberaBanca =  response.importoDeliberaBanca;
            self.showNote = response.showNoteIstrBeni;
            if(self.showNote){
              self.noteIstrBeni = response.noteIstrBeni;
            }
          }
          self.validate();
        })
      }

      var getAllAbi = function(){
        $typeDomainService.
          getDomainSet("N_DELIBERA_MANDATORY","M16")
          .then(function(response){
            var lista = response.domainList;

          self.requiredNumDelibera = lista.some(function(element){
            if(element.value === self.financialVendor.filiale.abi){
              return true;
            }
          })
          })
      }
      self.showModal = function(){
        $modalService.openModal("noteIstrBeniModal");
      }

      self.closeModal = function(){
        $modalService.closeModal("noteIstrBeniModal");
      }
      self.confirmModal = function(){
        self.noteConfirmed = true;
        self.closeModal();
        self.validate();
      }
    } 
  });